import { Component, Input } from '@angular/core';
import { LibellesService } from 'src/app/core/libelles.service';
import { FormulaireService } from 'src/app/saisie/formulaire.service';
import { ModeRenduService } from 'src/app/saisie/mode-rendu/mode-rendu.service';
import { FiltreService } from '../../../filtre.service';
import { FloatMaskInputComponent } from '../../float-mask-input/float-mask-input.component';

@Component({
  selector: 'bis-float-mask-inline-input-keypad',
  templateUrl: './float-mask-inline-input-keypad.component.html',
  styleUrls: ['../../input/input.component.css']
})
export class FloatMaskInlineInputKeypadComponent extends FloatMaskInputComponent {
  @Input()
  classeSupplLabel: string = 'text-right';
  @Input()
  classeSupplInput: string = '';
  @Input()
  classeColLabel: string = 'col-2';
  @Input()
  classeColInput: string = 'col-8';
      
  constructor(
    protected formulaireService: FormulaireService,
    protected libelleService: LibellesService,
    protected filtreService: FiltreService,
    public modeRenduService: ModeRenduService
    ) {
     super(formulaireService, libelleService, filtreService, modeRenduService);
   }

  public scroll(element: any) {
    element.scrollIntoView({block: 'center', behavior: 'auto'});
  }
}